import { Stack } from '@mantine/core';
import { PageTitle } from 'components/PageTitle';
import { useCompanyConfiguration } from 'init/use-company-configuration';
import { i18nKeys, useTranslation } from 'locales';
import { CommunicationLocalesCard } from 'modules/Settings/Configuration/CommunicationLocales';
import { ExternalMailboxCard } from 'modules/Settings/Configuration/ExternalMailbox';
import { PaymentPlanCard } from 'modules/Settings/Configuration/PaymentPlan';
import { PostalSendingCard } from 'modules/Settings/Configuration/PostalSending';
import { SendingPreferencesCard } from 'modules/Settings/Configuration/SendingPreferences';
import { TermsAndConditionsCard } from 'modules/Settings/Configuration/TermsAndConditions';
import classes from './Configuration.module.css';
import { TaskSettings } from './Task';

export const ConfigurationSettings = () => {
  const { t } = useTranslation();

  const company = useCompanyConfiguration();

  return (
    <>
      <PageTitle>{t(i18nKeys.SETTINGS.PREFERENCES.TITLE)}</PageTitle>
      <Stack pb="xl">
        <TermsAndConditionsCard />
        <div className={classes.container}>
          <div className={classes.layout}>
            <Stack gap="md">
              <SendingPreferencesCard />
              {company.package.can_use_external_mails && <ExternalMailboxCard />}
            </Stack>
            <Stack gap="md">
              <PostalSendingCard />
              <PaymentPlanCard />
              {company.package.can_use_tasks && <TaskSettings />}
              <CommunicationLocalesCard />
            </Stack>
          </div>
        </div>
      </Stack>
    </>
  );
};
